<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">اشخاص</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreate" variant="primary" class="px-3">
                    ایجاد
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-row class="mb-2 mb-md-50">
                <b-col md="3" class="mt-25">
                    <b-form-group label="نام" label-for="searchNameId">
                        <b-form-input v-model="parameters.name" dir="rtl" id="searchNameId" class="text-center"
                            autocomplete="off" name="searchNameId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-25">
                    <b-form-group label="نقش" label-for="roleId2">
                        <v-select v-model="parameters.role" :searchable="false" id="roleId2" dir="rtl"
                            :options="roleroleFilter" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-25">
                    <b-form-group label="شماره همراه" label-for="searchPhoneNumberId">
                        <b-form-input v-model="parameters.phoneNumber" dir="rtl" id="searchPhoneNumberId"
                            class="text-center" autocomplete="off" name="searchPhoneNumberId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-md-2 mt-50">
                    <b-button variant="info" @click="getwarehousingPeople" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>جستجو</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <b-card class="p-0" no-body>
                <div v-if="people.length">
                    <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-table responsive :items="people" :fields="fields" class="mb-0" striped>
                            <template #cell(edit)="data">
                                <feather-icon @click="showModalEdit(data.item)" size="18" icon="EditIcon"
                                    class="pointer text-info" color="#8d88a3" />
                            </template>
                            <template #cell(role)="data">
                                {{ role_management(data.item.role) }}
                            </template>
                            <template #cell(address)="data">
                                <span v-if="data.item.address" v-b-popover.hover.top="data.item.address"
                                    :title="data.item.name" class="text-info pointer">
                                    <feather-icon icon="FileTextIcon" size="20" />
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </template>
                            <template #cell(landlineNumber)="data">
                                <span v-if="data.item.landlineNumber">{{ data.item.landlineNumber }}</span>
                                <span v-else>-</span>
                            </template>
                            <template #cell(phoneNumber)="data">
                                <span v-if="data.item.phoneNumber">{{ data.item.phoneNumber }}</span>
                                <span v-else>-</span>
                            </template>
                            <template #cell(description)="data">
                                <span v-if="data.item.description" v-b-popover.hover.top="data.item.description"
                                    :title="data.item.name" class="text-info pointer">
                                    <feather-icon icon="FileTextIcon" size="20" />
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </template>
                            <template #cell(createdAt)="data">
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                            <template #cell(lastModifiedAt)="data">
                                <span>
                                    {{ new Date(data.item.lastModifiedAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.lastModifiedAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                        </b-table>
                    </b-overlay>
                </div>
                <div v-else class="text-center py-5">
                    موردی وجود ندارد
                </div>
            </b-card>
            <b-pagination align="center" @input="getwarehousingPeople" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create and edit ------------------------------->
        <b-modal id="warehousing-people" :title="`${personMode}`" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <validation-observer ref="warehousingPeopleValidation">
                    <b-form @submit.prevent>

                        <!-- name -->
                        <b-form-group label="نام" label-for="nameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="nameId" v-model="form.name" name="name"
                                    class="text-center user-select-none" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!------------ role ------------>
                        <b-form-group label="نقش" label-for="roleId" class="text-center">
                            <validation-provider #default="{ errors }" name="نقش" rules="required">
                                <v-select v-model="form.role" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white"
                                    :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="role">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- phoneNumber -->
                        <b-form-group label="شماره همراه" label-for="phoneNumberId" class="text-center">
                            <b-form-input autocomplete="off" dir="ltr" id="phoneNumberId" v-model="form.phoneNumber"
                                name="phoneNumber" type="number" class="text-center user-select-none" />
                        </b-form-group>

                        <!-- landlineNumber -->
                        <b-form-group label="شماره ثابت" label-for="landlineNumberId" class="text-center">
                            <b-form-input autocomplete="off" dir="ltr" id="landlineNumberId"
                                v-model="form.landlineNumber" name="landlineNumber" type="number"
                                class="text-center user-select-none" />
                        </b-form-group>

                        <!-- address -->
                        <b-form-group label=" آدرس" label-for="addressId" class="text-center">
                            <b-form-input autocomplete="off" dir="rtl" id="addressId" v-model="form.address"
                                name="address" class="text-center user-select-none" />
                        </b-form-group>

                        <!-- description -->
                        <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                            <b-form-textarea rows="2" no-resize autocomplete="off" dir="rtl" id="descriptionId"
                                v-model="form.description" name="description"></b-form-textarea>
                        </b-form-group>

                        <b-button type="submit" variant="primary" @click="managementPeople" :disabled="loadingButton"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ personMode }}</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { VBPopover, BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge,
        vSelect
    },
    directives: {
        'b-popover': VBPopover,
    },
    computed: {
        role_management() {
            return (status) => {
                if (status == 0) {
                    return 'خریدار'
                }
                if (status == 1) {
                    return 'فروشنده'
                }
                if (status == 2) {
                    return 'خریدار و فروشنده'
                }
            }
        },
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingButton: false,
            isAdminIdentityVerified: false,
            people: [],
            fields: [
                {
                    key: 'number',
                    label: 'شناسه',
                },
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'role',
                    label: 'نقش',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'landlineNumber',
                    label: 'شماره ثابت',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ایجاد',
                },
                {
                    key: 'lastModifiedAt',
                    label: 'تاریخ آخرین ویرایش',
                },
                {
                    key: 'address',
                    label: 'آدرس',
                },
                {
                    key: 'description',
                    label: 'توضیحات',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            role: [
                { name: 'خریدار', id: 0 },
                { name: 'فروشنده', id: 1 },
                { name: 'خریدار و فروشنده', id: 2 }
            ],
            roleroleFilter: [
                { name: 'همه', id: null },
                { name: 'خریدار', id: 0 },
                { name: 'فروشنده', id: 1 },
                { name: 'خریدار و فروشنده', id: 2 }
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                name: null,
                phoneNumber: null,
                role: null,
                totalCount: null
            },
            storeId: null,
            form: {
                name: null,
                landlineNumber: null,
                phoneNumber: null,
                address: null,
                description: null,
                role: null,
            },
            personMode: null,
            personId: null,
        }
    },
    methods: {
        managementPeople() {
            if (this.personMode == 'ایجاد') {
                this.createWarehousingPeople()
            }
            if (this.personMode == 'ویرایش') {
                this.editWarehousingPeople()
            }
        },
        showModalEdit(item) {
            if (this.accessHandling('employee', 'warehouse_people_manage')) {
                this.personMode = 'ویرایش'
                this.personId = item.id
                this.form.name = item.name
                this.form.description = item.description
                this.form.role = item.role
                this.form.landlineNumber = item.landlineNumber
                this.form.phoneNumber = item.phoneNumber
                this.form.address = item.address
                this.$bvModal.show('warehousing-people')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalCreate() {
            if (this.accessHandling('employee', 'warehouse_people_manage')) {
                this.personMode = 'ایجاد'
                this.form.name = null
                this.form.description = null
                this.form.landlineNumber = null
                this.form.phoneNumber = null
                this.form.address = null
                this.form.role = null
                this.$bvModal.show('warehousing-people')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        editWarehousingPeople() {
            this.$refs.warehousingPeopleValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.editWarehousingPeople(this.storeId, this.personId, this.form).then(({ data }) => {
                        this.$refs.warehousingPeopleValidation.reset();
                        this.$notif({ type: 'success', title: 'شخص با موفقیت ویرایش شد' });
                        this.$bvModal.hide('warehousing-people')
                        this.getwarehousingPeople()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        createWarehousingPeople() {
            this.$refs.warehousingPeopleValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.warehousingPeople(this.storeId, this.form).then(({ data }) => {
                        this.$refs.warehousingPeopleValidation.reset();
                        this.$notif({ type: 'success', title: 'شخص با موفقیت ایجاد شد' });
                        this.$bvModal.hide('warehousing-people')
                        this.getwarehousingPeople()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getwarehousingPeople();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getwarehousingPeople() {
            this.loading = true
            storeService.getwarehousingPeople(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.people = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.people = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>